import React from "react";
import { Modal, ConfigProvider } from "antd";
import InputForm from "./InputForm";
import { useTranslation } from "react-i18next";

export default function ModalForm(props) {
    const { t } = useTranslation();

    // функция закрытия модального окна при нажатии иконку х
    const handleCancel = () => {
        props.setIsModalOpen(false);
    };

    return (
        <>
        <ConfigProvider
            theme={{
                token: {
                    Modal: {
                        colorBgMask: "rgba(0, 0, 0, 0.55)",
                        fontSizeHeading5: 22,
                        lineHeightHeading5: 3,
                        margin: "5rem",
                    }
                },
            }}>
            <Modal
                title={t("modal_title")}
                open={props.isModalOpen}
                onCancel={handleCancel}
                footer={null}
                centered={true}
                className="modal"
                keyboard ="true"
            >
                <div>
                    <InputForm closeModal={handleCancel}/>
                </div>
            </Modal>    
        </ConfigProvider>
            
        </>
    );
}
